import Box from 'components/shared/Box'
import Price from 'components/shared/Price'
import Text from 'components/shared/Text'
import { formatPrice } from 'helpers/helpers'
import { FormattedMessage } from 'react-intl'
import Loader from 'components/shared/Loader'

interface SelfcarePlaceOrderSectionWithVouchersProps {
    isSelfcareCartFetching: boolean
    payByCardPrice: number | null
    remainingCardValue: number | null
}

export const SelfcarePlaceOrderSectionWithVouchers = ({
    isSelfcareCartFetching,
    payByCardPrice,
    remainingCardValue,
}: SelfcarePlaceOrderSectionWithVouchersProps) => (
    <Box isFullWidth gap={8}>
        <Box isFullWidth>
            <Box
                direction="row"
                justify="space-between"
                align="flex-end"
                isFullWidth
            >
                <Text variant="body" color="grayscale_900">
                    <FormattedMessage
                        id="vouchers.payment.delivery_cost_label_voucher"
                        defaultMessage="Z vouchera:"
                    />
                </Text>
                {isSelfcareCartFetching ? (
                    <Loader />
                ) : (
                    <Price
                        size="heading4"
                        isNegative
                        value={payByCardPrice}
                        color="grayscale_900"
                    />
                )}
            </Box>
            {remainingCardValue ? (
                <Text variant="bodySmall" color="grayscale_700">
                    <FormattedMessage
                        id="vouchers.payment.delivery_cost_label_voucher_remaining"
                        defaultMessage="Na voucherze pozostanie <price></price>"
                        values={{
                            price: () => (
                                <>
                                    <Text
                                        as="span"
                                        variant="bodySmall"
                                        color="grayscale_700"
                                    >
                                        {formatPrice(remainingCardValue, true)}
                                    </Text>
                                </>
                            ),
                        }}
                    />
                </Text>
            ) : null}
        </Box>
    </Box>
)
